var Afghanistan = "Афганистан";
var Albania = "Албания";
var Algeria = "Алжир";
var Andorra = "Андорра";
var Angola = "Ангола";
var Anguilla = "Ангилья";
var Antarctica = "Антарктика";
var Argentina = "Аргентина";
var Armenia = "Армения";
var Aruba = "Аруба";
var Australia = "Австралия";
var Austria = "Австрия";
var Azerbaijan = "Азербайджан";
var Bahamas = "Багамские Острова";
var Bahrain = "Бахрейн";
var Bangladesh = "Бангладеш";
var Barbados = "Барбадос";
var Belarus = "Беларусь";
var Belgium = "Бельгия";
var Belize = "Белиз";
var Benin = "Бенин";
var Bermuda = "Бермудские острова";
var Bhutan = "Бутан";
var Bolivia = "Боливия";
var Botswana = "Ботсвана";
var Brazil = "Бразилия";
var Bulgaria = "Болгария";
var Burundi = "Бурунди";
var Cambodia = "Камбоджа";
var Cameroon = "Камерун";
var Canada = "Канада";
var Chad = "Чад";
var Chile = "Чили";
var China = "Китай";
var Colombia = "Колумбия";
var Comoros = "Коморские Острова";
var Congo = "Конго";
var Croatia = "Хорватия";
var Cuba = "Куба";
var Cyprus = "Кипр";
var Denmark = "Дания";
var Djibouti = "Джибути";
var Dominica = "Доминика";
var Ecuador = "Эквадор";
var Egypt = "Египет";
var Eritrea = "Эритрея";
var Estonia = "Эстония";
var Ethiopia = "Эфиопия";
var Fiji = "Фиджи";
var Finland = "Финляндия";
var France = "Франция";
var Gabon = "Габон";
var Gambia = "Гамбия";
var Georgia = "Грузия";
var Germany = "Германия";
var Ghana = "Гана";
var Gibraltar = "Гибралтар";
var Greece = "Греция";
var Greenland = "Гренландия";
var Grenada = "Гренада";
var Guadeloupe = "Гваделупа";
var Guam = "Гуам";
var Guatemala = "Гватемала";
var Guernsey = "Гернси";
var Guinea = "Гвинея";
var Guyana = "Гайана";
var Haiti = "Гаити";
var Honduras = "Гондурас";
var Hungary = "Венгрия";
var Iceland = "Исландия";
var India = "Индия";
var Indonesia = "Индонезия";
var Iraq = "Ирак";
var Ireland = "Ирландия";
var Israel = "Израиль";
var Italy = "Италия";
var Jamaica = "Ямайка";
var Japan = "Япония";
var Jersey = "Остров Джерси";
var Jordan = "Иордания";
var Kazakhstan = "Казахстан";
var Kenya = "Кения";
var Kiribati = "Кирибати";
var Kuwait = "Кувейт";
var Kyrgyzstan = "Киргизия";
var Latvia = "Латвия";
var Lebanon = "Ливан";
var Lesotho = "Лесото";
var Liberia = "Либерия";
var Libya = "Ливийская Арабская Джамахирия";
var Liechtenstein = "Лихтенштейн";
var Lithuania = "Литва";
var Luxembourg = "Люксембург";
var Macao = "Макао";
var Madagascar = "Мадагаскар";
var Malawi = "Малави";
var Malaysia = "Малайзия";
var Maldives = "Мальдивы";
var Mali = "Мали";
var Malta = "Мальта";
var Martinique = "Мартиника";
var Mauritania = "Мавритания";
var Mauritius = "Маврикий";
var Mayotte = "Майотта";
var Mexico = "Мексика";
var Monaco = "Монако";
var Mongolia = "Монголия";
var Montenegro = "Черногория";
var Montserrat = "Монтсеррат";
var Morocco = "Марокко";
var Mozambique = "Мозамбик";
var Myanmar = "Мьянма";
var Namibia = "Намибия";
var Nauru = "Науру";
var Nepal = "Непал";
var Netherlands = "Нидерланды";
var Nicaragua = "Никарагуа";
var Niger = "Нигер";
var Nigeria = "Нигерия";
var Niue = "Ниуэ";
var Norway = "Норвегия";
var Oman = "Оман";
var Pakistan = "Пакистан";
var Palau = "Палау";
var Panama = "Панама";
var Paraguay = "Парагвай";
var Peru = "Перу";
var Philippines = "Филиппины";
var Pitcairn = "Питкерн";
var Poland = "Польша";
var Portugal = "Португалия";
var Qatar = "Катар";
var Romania = "Румыния";
var Rwanda = "Руанда";
var Samoa = "Самоа";
var Senegal = "Сенегал";
var Serbia = "Сербия";
var Seychelles = "Сейшельские Острова";
var Singapore = "Сингапур";
var Slovakia = "Словакия";
var Slovenia = "Словения";
var Somalia = "Сомали";
var Spain = "Испания";
var Sudan = "Судан";
var Suriname = "Суринам";
var Swaziland = "Свазиленд";
var Sweden = "Швеция";
var Switzerland = "Швейцария";
var Taiwan = "Тайвань";
var Tajikistan = "Таджикистан";
var Thailand = "Таиланд";
var Togo = "Того";
var Tokelau = "Токелау";
var Tonga = "Тонга";
var Tunisia = "Тунис";
var Turkey = "Турция";
var Turkmenistan = "Туркменистан";
var Tuvalu = "Тувалу";
var Uganda = "Уганда";
var Ukraine = "Украина";
var Uruguay = "Уругвай";
var Uzbekistan = "Узбекистан";
var Vanuatu = "Вануату";
var Venezuela = "Венесуэла";
var Yemen = "Йемен";
var Zambia = "Замбия";
var Zimbabwe = "Зимбабве";
var countries = {
	"Country or region": "Страна или регион",
	"United States": "США",
	Afghanistan: Afghanistan,
	"Åland Islands": "Аландские острова",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Американское Самоа",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Антигуа и Барбуда",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Босния и Герцеговина",
	Botswana: Botswana,
	"Bouvet Island": "Остров Буве",
	Brazil: Brazil,
	"British Indian Ocean Territory": "Британская территория в Индийском океане",
	"Brunei Darussalam": "Бруней‑Даруссалам",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Буркина‑Фасо",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Кабо‑Верде",
	"Cayman Islands": "Каймановы острова",
	"Central African Republic": "Центральная Африканская Республика",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Остров Рождества",
	"Cocos (Keeling) Islands": "Кокосовые острова",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Конго, Демократическая Республика",
	"Cook Islands": "Острова Кука",
	"Costa Rica": "Коста‑Рика",
	"Côte d'Ivoire": "Кот‑д’Ивуар",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Чехия",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Доминиканская Республика",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "Сальвадор",
	"Equatorial Guinea": "Экваториальная Гвинея",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Фолклендские острова (Мальвинские)",
	"Faroe Islands": "Фарерские острова",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Французская Гвиана",
	"French Polynesia": "Французская Полинезия",
	"French Southern Territories": "Французские Южные Территории",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Гвинея‑Бисау",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Остров Херд и острова Макдональд",
	"Holy See (Vatican City State)": "Святой Престол (Ватикан)",
	Honduras: Honduras,
	"Hong Kong": "Гонконг",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "Иран, Исламская Республика",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Остров Мэн",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Корейская Народно‑Демократическая Республика",
	"Korea, Republic of": "Корея, Республика",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Лаосская Народно‑Демократическая Республика",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Македония, бывшая югославская Республика",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Маршалловы Острова",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Федеративные Штаты Микронезии",
	"Moldova, Republic of": "Молдова, Республика",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Нидерландские Антильские Острова",
	"New Caledonia": "Новая Каледония",
	"New Zealand": "Новая Зеландия",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Остров Норфолк",
	"Northern Mariana Islands": "Северные Марианские Острова",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "Палестинские территории, оккупированные",
	Panama: Panama,
	"Papua New Guinea": "Папуа — Новая Гвинея",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Пуэрто-Рико",
	Qatar: Qatar,
	"Réunion": "Реюньон",
	Romania: Romania,
	"Russian Federation": "Российская Федерация",
	Rwanda: Rwanda,
	"Saint Helena": "Остров Святой Елены",
	"Saint Kitts and Nevis": "Сент‑Китс и Невис",
	"Saint Lucia": "Сент‑Люсия",
	"Saint Pierre and Miquelon": "Сен-Пьер и Микелон",
	"Saint Vincent and The Grenadines": "Сент‑Винсент и Гренадины",
	Samoa: Samoa,
	"San Marino": "Сан‑Марино",
	"Sao Tome and Principe": "Сан‑Томе и Принсипи",
	"Saudi Arabia": "Саудовская Аравия",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Сьерра‑Леоне",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Соломоновы Острова",
	Somalia: Somalia,
	"South Africa": "ЮАР",
	"South Georgia and The South Sandwich Islands": "Южная Джорджия и Южные Сандвичевы острова",
	Spain: Spain,
	"Sri Lanka": "Шри‑Ланка",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Шпицберген и Ян-Майен",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Сирийская Арабская Республика",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Танзания, Объединенная Республика",
	Thailand: Thailand,
	"Timor-Leste": "Тимор‑Лешти",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Тринидад и Тобаго",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Теркс и Кайкос",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Объединенные Арабские Эмираты",
	"United Kingdom": "Великобритания",
	"United States Minor Outlying Islands": "Малые Тихоокеанские отдаленные острова Соединенных Штатов",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Вьетнам",
	"Virgin Islands, British": "Виргинские острова, Британские",
	"Virgin Islands, U.S.": "Виргинские острова, США",
	"Wallis and Futuna": "Уоллис и Футуна",
	"Western Sahara": "Западная Сахара",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
